/*
 * Copyright (c) 2023. Vitalii Kozyr
 */

package core.domain.model

enum class AuthState {
    LOGGED_IN,
    LOGGED_OUT,
    NEW_PASSWORD_REQUIRED
}